import { useState } from "react";
import { mergeDeep } from "@apollo/client/utilities";

import { useMe, useFilterStorage } from "components/use-hooks";

const useDamageFilterHook = ({
    filter: filterParams = {}
} = {}) => {
    const { me } = useMe(),
        filterStorage = useFilterStorage();

    const defaultFilter = {
        where: {
            status: {
                column: "STATUS",
                operator: "NOT_IN",
                value: ["delete"]
            },
            eeId: {
                column: "EE_ID",
                operator: "EQ",
                value: me.eeCurrentId
            }
        },
        whereStand: {
            hallName: {},
            block: {},
            standNumber: {}
        },
        activeFilters: 0
    };

    const [filter, setFilter] = useState(mergeDeep(defaultFilter, filterParams));

    filterStorage.store("view_damages", {
        filter
    });

    return {
        filter: {
            data: filter,
            set: setFilter,
            reset: () => setFilter(defaultFilter)
        }
    };
};

export default useDamageFilterHook;
